export const XIcon = () => (
  <svg viewBox="0 0 31.28 31.28" width="50" height="50">
    <polygon fill="#fd0" points="31.28 4.59 26.69 0 15.64 11.05 4.59 0 0 4.59 11.05 15.64 0 26.69 4.59 31.28 15.64 20.23 26.69 31.28 31.28 26.69 20.23 15.64 31.28 4.59"/>
  </svg>
);

export const BigXIcon = () => (
  <svg viewBox="0 0 31.28 31.28" width="50" height="50">
    <polygon fill="#e50076" points="31.28 4.59 26.69 0 18.33 8.36 18.33 0 12.95 0 12.95 8.36 4.59 0 0 4.59 8.36 12.95 0 12.95 0 18.33 8.36 18.33 0 26.69 4.59 31.28 12.95 22.92 12.95 31.28 18.33 31.28 18.33 22.92 26.69 31.28 31.28 26.69 22.92 18.33 31.28 18.33 31.28 12.95 22.92 12.95 31.28 4.59"/>
  </svg>
);

export const VIcon = () => (
  <svg viewBox="0 0 29.79 29.69" width="50" height="50">
    <polygon fill="#1d9dd9" points="9.4 19.8 4.48 15.43 0 20.49 10.38 29.69 29.79 4.08 24.4 0 9.4 19.8"/>
  </svg>
);

export const BigVIcon = () => (
  <svg viewBox="0 0 38.64 29.69" width="50" height="50">
    <polygon fill="#1d9dd9" points="22.37 .07 8.62 18.22 4.1 14.22 0 18.85 9.52 27.28 27.3 3.81 22.37 .07"/>
    <rect fill="#1d9dd9" x="9.28" y="11.75" width="33.12" height="6.19" transform="translate(-1.92 25.68) rotate(-51.18)"/>
  </svg>
);

